export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./src/axis";



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-axis/index.js
// module id = 225
// module chunks = 0 1 2 3 4